<template>
  <div>
    <div class="action-plan-title">
      <div class="action-plan-title-text">
        {{ this.title }}
      </div>
      <chevrons
        class="actionPlanTitleChevron"
        :is-large="true"
        :is-open="this.isOpen"
        @on-chevon-click="toggleChevron"
      />
    </div>

    <div v-if="this.isOpen">
      <b-table :items="tableData" :fields="this.fields">
        <template #cell(reportName)="data">
          <div class="row-text">{{ data.value }}</div>
        </template>
        <template #cell(contentName)="data">
          <div class="row-container">
            <b-form-input
              class="table-edit-field"
              v-if="tableData[data.index].isEdit"
              type="text"
              v-model="tableData[data.index].contentName"
            >
            </b-form-input>
            <div v-else class="row-text">
              {{ data.value }}
            </div>
          </div>
        </template>
        <template #cell(description)="data">
          <div class="row-container">
            <b-form-textarea
              class="table-edit-field"
              rows="2"
              max-rows="3"
              v-if="tableData[data.index].isEdit"
              v-model="tableData[data.index].description"
            >
            </b-form-textarea>
            <div v-else class="row-text">{{ data.value }}</div>
          </div>
        </template>
        <template #cell(edit)="data">
          <button class="inline-edit-button" @click="editRowHandler(data)">
            <span v-if="!tableData[data.index].isEdit">
              <button class="modal-btn modal-save-btn">
                {{ getMessageText(messages.Edit) }}
              </button>
            </span>
            <span v-else>
              <button
                class="modal-btn modal-save-btn"
                @click="emitChangedField(data.index)"
              >
                {{ getMessageText(messages.SAVE) }}
              </button>
            </span>
          </button>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
  import Chevrons from "@/views/drag-drop-pages/components/Chevrons.vue";
  import { mapState } from "vuex";

  export default {
    name: "ImportCustomContentModalSectionEditable",
    components: {
      Chevrons
    },
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      })
    },
    props: {
      title: {
        default: function() {
          return {};
        },
        type: Object
      },
      content: {
        default: function() {
          return {};
        },
        type: Object
      },
      fields: {
        default: function() {
          return [];
        },
        type: Object
      }
    },
    data() {
      return {
        isOpen: false,
        tableData: []
      };
    },
    created() {
      this.setDataAsArray();
      this.addEditToFields();
    },
    methods: {
      toggleChevron() {
        this.isOpen = !this.isOpen;
      },
      addEditToFields() {
        this.fields = this.fields.push({
          key: "edit",
          label: "",
          thStyle: { width: "25px" }
        });
      },
      setDataAsArray() {
        this.tableData = Object.keys(this.content).map(key => ({
          ...this.content[key],
          isEdit: false,
          contentId: key
        }));
      },
      editRowHandler(data) {
        this.tableData[data.index].isEdit = !this.tableData[data.index].isEdit;
      },
      emitChangedField(index) {
        const contentId = this.tableData[index].contentId;
        const newContentName = this.tableData[index].contentName;
        const newDescription = this.tableData[index].description;
        this.$emit(
          "action-plan-field-changed",
          contentId,
          newContentName,
          newDescription
        );
      }
    }
  };
</script>

<style scoped>
  .inline-edit-button {
    background: none;
    border: none;
  }

  .row-text {
    min-height: calc(1.5em + 0.75rem + 2px);
    margin: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    word-break: break-all;
    overflow-wrap: break-word;
    font-size: 0.8875rem;
  }

  .action-plan-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1rem;
    padding-bottom: 24px;
  }

  .modal-btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 0;
    background: transparent;
    background-clip: border-box;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    line-height: 1.875rem;
    color: var(--BTN_BG_BLUE, #0070d2);
    -webkit-appearance: none;
    white-space: normal;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-decoration: none;
  }

  .table-edit-field {
    font-size: 0.8875rem;
    transform: translateX(-13px);
    max-width: 25vw;
  }

  .row-container {
    display: flex;
    align-content: center;
    font-size: 0.8875rem;
    max-width: 25vw;
  }
</style>
